import { action, observable } from 'mobx'

import Ds from './ds'

class BillingStatuses {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllBillingStatuses() {
    this.ds.query(`{ billingStatuses(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.billingStatuses
    })
  }

  @action newBillingStatus(name) {
    this.ds.query(`mutation { addBillingStatus(name: "${ name }") { id } }`, (data) => {
      this.loadAllBillingStatuses()
    })
  }

  @action updateBillingStatus(id, name) {
    this.ds.query(`mutation { updateBillingStatus(id: ${ id }, name: "${ name }") { id } }`, (data) => {
      this.loadAllBillingStatuses()
    })
  }

  @action deleteBillingStatus(id) {
    this.ds.query(`mutation { deleteBillingStatus(id: ${ id }) { id } }`, (data) => {
      this.loadAllBillingStatuses()
    })
  }
}

export default new BillingStatuses



// WEBPACK FOOTER //
// ./src/stores/billingstatuses.js